import { useTranslation } from 'react-i18next'

import Button, { ButtonArrow } from '../../../Button'
import { Counter, TABLE_VARIANT } from '../../../Counter'
import Text from '../../../Text'
import {
  QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_ROW,
  QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_TOGGLE,
} from '../../DashboardBirdview.constants.qa'
import { DashboardSeverityDot } from '../../DashboardSeverityDot'

import * as styles from './BirdviewAttentionRowHeader.module.css'

function BirdviewAttentionRowHeader({ isOpen, item, onToggle }) {
  const { t } = useTranslation()

  return (
    <div className={styles.header}>
      <Button.Text
        isGrey
        className={styles.toggle}
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_ROW}
        onClick={onToggle}
      >
        <DashboardSeverityDot tone={item.tone} />
        <Text className={styles.reason}>{t(item.labelKey)}</Text>
        <Counter count={item.count} variant={TABLE_VARIANT} />
      </Button.Text>
      <ButtonArrow
        getTooltip={null}
        isOpen={isOpen}
        qaName={QA_NAME_DASHBOARD_BIRDVIEW_ATTENTION_TOGGLE}
        onClick={onToggle}
      />
    </div>
  )
}

export default BirdviewAttentionRowHeader
